import React, { useState } from "react";
import upload_area from "../Pages/CSS/upload_area.svg";
import "./CSS/Sell.css";

const AddProduct = () => {
  const [image, setImage] = useState(null);
  const [productDetails, setProductDetails] = useState({
    name: "",
    description: "",
    image: "",
    category: "electronics",
    new_price: "",
    old_price: "",
    sellerName: "",
    sellerMobile: "",
    sellerEmail: ""
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleAddProduct = async () => {
    // Check if all text inputs are filled
    const { name, description, new_price, old_price, sellerName, sellerMobile, sellerEmail } = productDetails;
    if (!name || !description || !new_price || !old_price || !sellerName || !sellerMobile || !sellerEmail) {
      alert("Please fill all the fields.");
      return;
    }

    setIsSubmitting(true); // Disable the button

    // Step 1: Prepare form data for image upload
    const formData = new FormData();
    formData.append("product", image); // Attach the selected image file
  
    let imageUploadData;
  
    // Step 2: Upload image to Cloudinary via backend
    try {
      console.log("Starting image upload...");
      const uploadResponse = await fetch("https://freecycle-backend-1.onrender.com/upload", {
        method: "POST",
        headers: {
          Accept: "application/json",
        },
        body: formData,
      });
  
      if (!uploadResponse.ok) {
        throw new Error(`Image upload failed with status: ${uploadResponse.status}`);
      }
  
      // Parse response to get Cloudinary image URL data
      imageUploadData = await uploadResponse.json();
      console.log("Image uploaded successfully:", imageUploadData);
  
    } catch (error) {
      console.error("Image upload error:", error);
      alert("Image upload failed. Please try again.");
      setIsSubmitting(false); // Re-enable the button
      return; // Exit function if image upload fails
    }
  
    // Step 3: Check if image upload was successful
    if (!imageUploadData || !imageUploadData.success) {
      alert("Image upload failed.");
      setIsSubmitting(false); // Re-enable the button
      return;
    }
  
    // Step 4: Prepare product data and send it to backend
    const product = { ...productDetails }; // Copy product details from form inputs
    console.log("Product data prepared:", product);
  
    // Step 5: Send product data to backend to save in MongoDB
    try {
      const addResponse = await fetch("https://freecycle-backend-1.onrender.com/addproduct", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ productDetails: JSON.stringify(product), image_url: imageUploadData.image_url }),
      });
  
      const addData = await addResponse.json();
      console.log("Product add response:", addData);
  
      if (addData && addData.success) {
        alert("Product added successfully!");
      } else {
        alert("Failed to add product.");
      }
    } catch (error) {
      console.error("Add product error:", error);
      alert("Failed to add product. Please try again.");
    } finally {
      setIsSubmitting(false); // Re-enable the button
    }
  };
  
  const changeHandler = (e) => {
    setProductDetails({ ...productDetails, [e.target.name]: e.target.value });
  };

  return (
    <div className="addproduct">
      <div className="addproduct-itemfield">
        <p>Product title</p>
        <input
          type="text"
          name="name"
          value={productDetails.name}
          onChange={changeHandler}
          placeholder="Type here"
          required
        />
      </div>
      <div className="addproduct-itemfield">
        <p>Seller Name</p>
        <input
          type="text"
          name="sellerName"
          value={productDetails.sellerName}
          onChange={changeHandler}
          placeholder="Type here"
          required
        />
      </div>
      <div className="addproduct-itemfield">
        <p>Seller Mobile Number</p>
        <input
          type="text"
          name="sellerMobile"
          value={productDetails.sellerMobile}
          onChange={changeHandler}
          placeholder="Type here"
          required
        />
      </div>
      <div className="addproduct-itemfield">
        <p>Seller Email ID</p>
        <input
          type="email"
          name="sellerEmail"
          value={productDetails.sellerEmail}
          onChange={changeHandler}
          placeholder="Type here"
          required
        />
      </div>
      <div className="addproduct-itemfield">
        <p>Product description</p>
        <input
          type="text"
          name="description"
          value={productDetails.description}
          onChange={changeHandler}
          placeholder="Type here"
          required
        />
      </div>
      <div className="addproduct-price">
        <div className="addproduct-itemfield">
          <p>Price</p>
          <input
            type="number"
            name="old_price"
            value={productDetails.old_price}
            onChange={changeHandler}
            placeholder="Type here"
            required
          />
        </div>
        <div className="addproduct-itemfield">
          <p>Offer Price</p>
          <input
            type="number"
            name="new_price"
            value={productDetails.new_price}
            onChange={changeHandler}
            placeholder="Type here"
            required
          />
        </div>
      </div>
      <div className="addproduct-itemfield">
        <p>Product category</p>
        <select
          value={productDetails.category}
          name="category"
          className="add-product-selector"
          onChange={changeHandler}
        >
          <option value="electronics">Electronics</option>
          <option value="study">Study Materials</option>
          <option value="sports">Sports</option>
          <option value="cycles">Cycles</option>
          <option value="clothes">Clothes</option>
          <option value="others">Others</option>
        </select>
      </div>
      <div className="addproduct-itemfield">
        <p>Product image</p>
        <label htmlFor="file-input">
          <img
            className="addproduct-thumbnail-img"
            src={!image ? upload_area : URL.createObjectURL(image)}
            alt=""
          />
        </label>
        <input
          onChange={(e) => setImage(e.target.files[0])}
          type="file"
          name="image"
          id="file-input"
          accept="image/*"
          hidden
        />
      </div>
      <button className="addproduct-btn" onClick={handleAddProduct} disabled={isSubmitting}>ADD</button>
    </div>
  );
};

export default AddProduct;
